export default __webpack_public_path__ + "static/media/website.8ac3b9d2.svg";